import React, { useState } from 'react';
import { Box } from '@mui/material';

const ImageWithFallback = ({ src, alt, fallbackSrc, styles }) => {
    const [imageSrc, setImageSrc] = useState(src);

    const handleError = () => {
        setImageSrc(fallbackSrc);
    };

    return (
        <img src={imageSrc} alt={alt} style={styles} onError={handleError} />
    );
};

export default ImageWithFallback;
